"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var module_util_1 = require("../../utils/module.util");
var bff_1 = require("./bff");
var jericho_1 = require("./jericho");
var couponApi = (0, module_util_1.getModules)({
    couponAction: {
        jerichoFn: jericho_1.couponAction_jericho,
        bffFn: bff_1.couponAction_bff,
    },
    couponDetails: {
        jerichoFn: jericho_1.couponDetails_jericho,
        bffFn: bff_1.couponDetails_bff,
    },
});
exports.default = couponApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/couponAPI/index.js
// module id = 3397
// module chunks = 11